import React from 'react'

function Ipad() {
  return (
    <div><br /><br /><br /><br />
        <h1 align='center'><b>IPAD Page</b></h1><br />
    </div>
  )
}

export default Ipad